import React, { useState, useCallback } from "react";
import styled from "styled-components";
import Textfield from "../components/Textfield.js";
import Textarea from "../components/Textarea.js";
import ContactContainer from "../components/ContactContainer.js";

const Container = styled.div`
  display: block;
  max-width: 300px;
  margin: auto;
  padding: 10px
`;


class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: "",
      lastname: "",
      email: "",
      subject: "",
      message: "",
      send: 0,
      privacy: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    console.log(value);
    const name = target.name;

    this.setState({ [name]: value });
  }

  handleSubmit = event => {
    if (!this.state.privacy) {
      this.setState({ send: 1 });
      event.preventDefault();
      return;
    };
    fetch("mail.php", {
      method: "POST",
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: `firstname=${this.state.firstname}&lastname=${this.state
        .lastname}&email=${this.state.email}&subject=${this.state
          .subject}&message=${this.state.message}`
    })
      .then((response) => {
        let state = { send: response.status };
        if (response.status == 200) {
          state.firstname = "";
          state.lastname = "";
          state.email = "";
          state.subject = "";
          state.message = "";
          state.privacy = false;
        };
        this.setState(state);
      })
      .catch(() => this.setState({ send: 500 }));
    event.preventDefault();
  };

  render() {
    return (
      <ContactContainer>
        <Container>
          <div>
            <h1>Kontakt</h1>
            Regina Prohn<br /><br />
            Neue Str. 21<br /><br />
            25355 Barmstedt<br /><br />
            Kontakt: Regina Prohn<br /><br />
            <div>
              Tel.: <a href="tel:+491725288803">+49 (0) 1725288803</a><br /><br />
            </div>
            <div>
              E-Mail: <a href="mailto:reginaprohn@tinkas-lifestyle.de">reginaprohn@tinkas-lifestyle.de</a><br />
            </div>

          </div>
        </Container>
      </ContactContainer>

    );
  }
}

export { Contact };
